// extracted by mini-css-extract-plugin
export default {"wrapper":"Error_wrapper__TBWz0","logo":"Error_logo__gA6F2","text":"Error_text__vn4xP"};